import {AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MobileInsuranceDetails, MobileScenarios} from '../../../model/MobileInsuranceModels';
import {MobileInsuranceService} from '../../../services/mobile-insurance.service';
import {Label, PaymentInfo, Response, StaticMethods, UploadInfo} from '../../../model/GeneralModels';
import {GeneralService} from '../../../services/general.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-mobile-request-info',
  templateUrl: './mobile-request-info.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class MobileRequestInfoComponent implements OnInit, AfterViewInit {
  requestInfo: MobileInsuranceDetails[] = [];
  paymentMode = false;
  paymentInfo: PaymentInfo = new PaymentInfo();
  formGroup: FormGroup;
  file = new Label('', '');
  pageStatus: string;
  buttonLabel = '';
  requestID: number;
  icon: string;
  public translation: any = {};
  fileInfo: UploadInfo;
  constructor(
    private service: MobileInsuranceService,
    private router: Router,
    private commonService: GeneralService,
    public settings: AppSettingsService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.formGroup = this.fb.group({
      discountCode: ['']
    });
  }

  ngAfterViewInit() {
    if (StaticMethods.checkState(this.router, ['requestID', 'icon'], '/MOBILE/requests')) {
      this.requestID = history.state.requestID;
      this.icon = history.state.icon;
      this.getDetails(history.state.requestID, () => {
        this.cdRef.detectChanges();
      });
    }
  }

  takeAction() {
    switch (this.requestInfo[0].getStep()) {
      case MobileScenarios.fileUploaded:
        this.redirectToUpload();
        break;
      case MobileScenarios.paid:
        this.showPaymentPanel();
        break;
      case MobileScenarios.insuranceReleased:
        this.download();
        break;
      case MobileScenarios.formSubmitted:
        this.fillForms();
        break;
      default:
        console.log(this.requestInfo[0].getStep());
    }
  }

  setButton(request: MobileInsuranceDetails) {
    switch (request.getStep()) {
      case MobileScenarios.fileUploaded:
        this.file = request.getFileType(this.settings);
        this.buttonLabel = 'اپلود عکس ' + this.file.getPersianLabel();
        break;
      case MobileScenarios.formSubmitted:
        this.buttonLabel = 'تکمیل اطلاعات';
        break;
      case MobileScenarios.paid:
        this.pageStatus = 'payment';
        this.buttonLabel = 'پرداخت حق بیمه';
        break;
      case MobileScenarios.waitingForRelease:
        this.pageStatus = MobileScenarios.waitingForRelease;
        this.buttonLabel = '';
        break;
      case MobileScenarios.insuranceReleased:
        this.pageStatus = MobileScenarios.insuranceReleased;
        this.buttonLabel = 'دانلود بیمه نامه';
        break;
    }
  }

  showPaymentPanel() {
    this.router.navigate([`/invoice/MOBILE/${this.requestID}`]);
  }

  download() {
    this.service.downloadNewInsurance(this.requestInfo[0].getRequestID()).subscribe((response: Response) => {
      if (response.success) {
        StaticMethods.goToLink(response.data.directLink);
      }
    });
  }

  hideFinance() {
    this.paymentMode = false;
  }

  private redirectToUpload() {
    this.fileInfo = {
      persianName: this.file.getPersianLabel(),
      englishName: this.file.getEnglishLabel(),
      id: this.requestInfo[0].getRequestID()
    };
  }

  private fillForms() {
    StaticMethods.fillForms(this.router, 'MOBILE', this.requestInfo[0].getRequestID(), this.icon);
  }

  hideUpload() {
    this.fileInfo = null;
    this.getDetails(history.state.requestID, () => {
      this.cdRef.detectChanges();
    });
  }

  private getDetails(requestID: number, cb: any) {
    this.service.getRequestInfo(requestID).subscribe((response: Response) => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        let scenario;
        switch (response.data.clientType) {
          case 'B2B':
            scenario = MobileScenarios.B2BScenario;
            break;
          default:
            scenario = MobileScenarios.generalScenario;
        }
        this.requestInfo[0] = new MobileInsuranceDetails(response.data, scenario);
        this.setButton(this.requestInfo[0]);
        cb();
      }
    });
  }
}
